function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
import React, { useContext } from 'react';
import { twMerge } from '@stereoagency/tailwind-config';
import { Body } from '../../atoms';
import { useAccentColors } from '../../hooks';
import ReactConfigContext from '../../ReactConfigContext';
export default function Tag(_0) {
    var _0_size = _0.size, size = _0_size === void 0 ? 'sm' : _0_size, _0_variant = _0.variant, variant = _0_variant === void 0 ? 'default' : _0_variant, className = _0.className, style = _0.style, accentColor = _0.accentColor, children = _0.children, props = _object_without_properties(_0, [
        "size",
        "variant",
        "className",
        "style",
        "accentColor",
        "children"
    ]);
    var _useContext = useContext(ReactConfigContext), LinkComponent = _useContext.config.LinkComponent;
    var accentStyle = useAccentColors([
        'colors-tag-bg-base',
        accentColor
    ]);
    var cx = twMerge('inline-block rounded-full', size !== 'md' && 'px-4', size === 'md' && 'px-4 py-2', variant === 'default' && 'bg-tag-bg-base', variant === 'ghost' && 'border py-2', className);
    var mergedStyle = _object_spread({}, style, accentStyle);
    var bodyCx = twMerge('leading-relaxed', size !== 'md' && 'font-semibold font-heading', size === 'md' && 'font-normal font-body', variant === 'default' && 'text-fg-inverted', variant === 'ghost' && 'text-fg-base font-body font-normal');
    if (props.href || props.onClick) {
        var _props_href;
        return /*#__PURE__*/ React.createElement(LinkComponent, _object_spread_props(_object_spread({}, props), {
            href: (_props_href = props.href) !== null && _props_href !== void 0 ? _props_href : '#',
            className: cx,
            style: mergedStyle
        }), /*#__PURE__*/ React.createElement(Body, {
            variant: size,
            className: bodyCx
        }, children));
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: cx,
        style: mergedStyle
    }, /*#__PURE__*/ React.createElement(Body, {
        variant: size,
        className: bodyCx
    }, children));
}

//# sourceMappingURL=Tag.js.map